// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1f6np","tab":"Tabs_tab__24Nqp","tabActive":"Tabs_tabActive__2Gl-A"};